const CLOUD = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;

/**
 * Optimise une image distante (affiche GitHub, etc.) via Cloudinary « fetch » :
 * format + qualité automatiques, redimension sans agrandir, et cache CDN.
 * Renvoie l'URL d'origine si Cloudinary n'est pas configuré ou si l'URL est
 * déjà sur Cloudinary / en data:.
 */
export function optimizedImage(url, width) {
  if (!CLOUD || !url) return url;
  if (url.startsWith('data:') || url.includes('res.cloudinary.com')) return url;

  const transforms = ['f_auto', 'q_auto', 'c_limit'];
  if (width) transforms.push(`w_${width}`);
  return `https://res.cloudinary.com/${CLOUD}/image/fetch/${transforms.join(',')}/${encodeURIComponent(url)}`;
}
